import React from 'react';
import { Box, Text } from '@wix/design-system';
import { PricingStrategy } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { AITldDisclaimer } from '../AITldDisclaimer/AITldDisclaimer';
import { ExperimentSpecs } from '../../constants';
import { PricingStrategyLabel } from './PricingStrategyLabels';
import styles from './Pricing.module.scss';
export const PricingContent = _ref => {
  var _getPremiumEssentials;
  let pricing = _ref.pricing,
    tld = _ref.tld,
    domainName = _ref.domainName,
    _ref$denseStrikethrou = _ref.denseStrikethroughStyle,
    denseStrikethroughStyle = _ref$denseStrikethrou === void 0 ? false : _ref$denseStrikethrou,
    _ref$useIntroPriceLab = _ref.useIntroPriceLabelCopy,
    useIntroPriceLabelCopy = _ref$useIntroPriceLab === void 0 ? false : _ref$useIntroPriceLab,
    _ref$matchStrikethrou = _ref.matchStrikethroughSize,
    matchStrikethroughSize = _ref$matchStrikethrou === void 0 ? false : _ref$matchStrikethrou,
    _ref$compactPriceLabe = _ref.compactPriceLabel,
    compactPriceLabel = _ref$compactPriceLabe === void 0 ? false : _ref$compactPriceLabe;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const experiments = (_getPremiumEssentials = getPremiumEssentialsSafe()) == null ? void 0 : _getPremiumEssentials.experiments;
  const isRenewalPricingEnabled = Boolean(experiments == null ? void 0 : experiments[ExperimentSpecs.RenewalPricingStrategy]);
  const priceSize = 'small';
  const strikethroughSize = matchStrikethroughSize ? priceSize : denseStrikethroughStyle ? 'tiny' : 'small';
  const strikethroughWeight = denseStrikethroughStyle ? 'normal' : 'thin';
  const strikethroughPrice = pricing.originalPrice;
  const displayPrice = pricing.price;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "2px",
    align: "right",
    verticalAlign: "bottom"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "0 SP1",
    verticalAlign: "bottom",
    flexWrap: "wrap"
  }, strikethroughPrice && /*#__PURE__*/React.createElement(Text, {
    size: strikethroughSize,
    weight: strikethroughWeight,
    secondary: true,
    light: true,
    className: styles.disabledText
  }, t('domain_search_suite.domain_gate.suggestions.card.domain_price', {
    domainPrice: strikethroughPrice
  })), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Text, {
    size: priceSize,
    weight: "normal"
  }, t('domain_search_suite.domain_gate.suggestions.card.domain_price', {
    domainPrice: displayPrice
  })), compactPriceLabel && /*#__PURE__*/React.createElement(PricingStrategyLabel, {
    pricing: pricing,
    domainName: domainName,
    useIntroPriceLabelCopy: useIntroPriceLabelCopy,
    compactPriceLabel: compactPriceLabel,
    iconOnly: true
  }), pricing.pricingStrategy === PricingStrategy.MULTI_YEAR_MINIMUM_COUNT && tld === 'ai' && (!pricing.renewalPrice || !isRenewalPricingEnabled) && /*#__PURE__*/React.createElement(AITldDisclaimer, {
    domainName: domainName
  })))), /*#__PURE__*/React.createElement(PricingStrategyLabel, {
    pricing: pricing,
    domainName: domainName,
    useIntroPriceLabelCopy: useIntroPriceLabelCopy,
    compactPriceLabel: compactPriceLabel,
    textOnly: compactPriceLabel
  }));
};
//# sourceMappingURL=PricingContent.js.map